import React, { useEffect, useState } from 'react';
import { FECHA_NAC_MIN, FECHA_NAC_MAX } from '../../components/fechaNacimiento';
import axios from '../../axiosConfig';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useParams, useNavigate } from 'react-router-dom';
import { useLoading } from '../../components/LoadingContext'; 
import { ToastContainer, toast } from 'react-toastify';
import PaginationTable from '../../components/PaginationTable'; // Importa el componente
import { Card, Row, Col } from 'react-bootstrap'; 
import { Modal, Table, Alert } from 'react-bootstrap';
import SelectComponent from '../../components/SelectComponent';
import { cohortesParaEdicion } from '../../components/cohorteUtils';
import { FaSearch } from 'react-icons/fa';  // Importamos íconos de react-icons
import estadosMunicipios from '../../components/estadosMunicipios.json';
import { DateTime } from 'luxon';
import EnviarPeticionModal from '../../components/EnviarPeticionModal';



const userId = parseInt(localStorage.getItem('user'));  // ID del usuario logueado


const ConfirmPartEInsc = () => {
    const { inscripcionId,id } = useParams();
    const [cursos, setCursos] = useState([]);
    const [searchCod, setSearchCod] = useState(''); // Nuevo estado para el buscador por COD
    const [filteredCursos, setFilteredCursos] = useState([]);
    const [searchCurso, setSearchCurso] = useState('');
    const [areaOptions, setAreaOptions] = useState([]);
    const [selectedArea, setSelectedArea] = useState('');
    const [error, setError] = useState(null);
    const { setLoading } = useLoading();
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);  // Estado para la página actual
    const [selectVisible, setSelectVisible] = useState(false);  // Control de la visibilidad de los selectores
    const [formErrors, setFormErrors] = useState({}); // Estado para almacenar los mensajes de error
    const [patrocinanteSeleccionado, setPatrocinanteSeleccionado] = useState(null);  // Estado para almacenar patrocinante seleccionado
    const handleCloseModal = () => setShowModal(false); // Cierra el modal
    const [showModal, setShowModal] = useState(false);  // Estado para mostrar/ocultar modal
    const [showModalDelete, setShowModalDelete] = useState(false);  // Estado para mostrar/ocultar modal
    const handleCloseModalDelete = () => setShowModalDelete(false); // Cierra el modal
    const [patrocinantes, setPatrocinantes] = useState([]); // Estado para lista de patrocinantes
    const [totalPages, setTotalPages] = useState(1);    // Total de páginas
    const [searchCedula, setSearchCedula] = useState('');    // Estado para controlar búsqueda por cédula
    const [datos, setDatos] = useState(null);
    const [inscripcion, setInscripcion] = useState(null);
    const [curso, setCurso] = useState(null);
    const [patrocinanteSeleccionado1, setPatrocinanteSeleccionado1] = useState(null);
    const [patrocinanteSeleccionado2, setPatrocinanteSeleccionado2] = useState(null);
    const [patrocinanteSeleccionado3, setPatrocinanteSeleccionado3] = useState(null);
    const [currentPatrocinante, setCurrentPatrocinante] = useState(null); // Para saber cuál botón abrió el modal
    const [paginatedPatrocinantes, setPaginatedPatrocinantes] = useState([]); // Patrocinantes en la página actual
    const [currentPagePatrocinantes, setCurrentPagePatrocinantes] = useState(1);
    const [isPatrocinado, setIsPatrocinado] = useState(false); // Estado para almacenar si es patrocinado
    const [mostrarPatrocinantes, setMostrarPatrocinantes] = useState(false);
    // Punto 6: a quien se manda el registro del pago de una U.C. aliada.
    const [showDestinoPago, setShowDestinoPago] = useState(false);
     const [municipiosDisponibles, setMunicipiosDisponibles] = useState([]);  
      const [originalCedula, setOriginalCedula] = useState('');
      const [cedulaError, setCedulaError] = useState(''); 
      const [isCedulaValid, setIsCedulaValid] = useState(false);
      const [cedulaLengthError, setCedulaLengthError] = useState('');
      
    

// Cursos que se mostrarán en la página actual




    const itemsPerPage = 3;  // Definir cuántos elementos por página

    
    useEffect(() => {
        console.log("ID de inscripción:", inscripcionId); // Para verificar si inscripcionId tiene valor
        getInscripcion();
     
        
    }, [inscripcionId]); // Ejecutar solo cuando cambia la cédula
    
    useEffect(() => {
        setLoading(true);
        handleSeleccionar(); // Solo ejecutar una vez, cuando se monta el componente
        handleSeleccionar2();
    }, []); // Ejecutar una vez, al montar
    
    const cursosPaginados = filteredCursos.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
        setFormData2(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const handleChangeNumber = (e) => {
  const { name, value } = e.target;

  // Permitir solo dígitos
  let newValue = value.replace(/\D/g, "");

  // Evitar que el primer dígito sea 0
  if (newValue.startsWith("0")) {
    newValue = newValue.slice(1);
  }

  // Limitar longitud a 10 caracteres
  if (newValue.length > 10) {
    newValue = newValue.slice(0, 10);
  }

  setFormData((prev) => ({
    ...prev,
    [name]: newValue,
  }));
};



const handleEstadoChange = (e) => {
    const estadoId = e.target.value;
    
    // Encuentra el estado seleccionado en el JSON
    const estadoSeleccionado = estadosMunicipios.find(estado => estado.id_estado === parseInt(estadoId));
    
    // Actualiza los municipios disponibles
    setMunicipiosDisponibles(estadoSeleccionado ? estadoSeleccionado.municipios : []);
    
    // Actualiza el estado seleccionado en formData
    setFormData({
      ...formData,
      estado_id: estadoId,
      municipio: ''  // Reseteamos el municipio al cambiar de estado
    });
  };

    const getPatrocinanteById = async (patrocinanteId) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/patrocinantes/${patrocinanteId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;  // Retorna el objeto del patrocinante
        } catch (error) {
            console.error(`Error obteniendo patrocinante con ID ${patrocinanteId}:`, error);
            return null;  // Si hay error, retornamos null
        }
    };
    

    const handleSeleccionarPatrocinante = (patrocinante) => {
        if (currentPatrocinante === 1) {
            setPatrocinanteSeleccionado1(patrocinante);
            setFormData2(prevData => ({ ...prevData, patrocinante_id: patrocinante.id }));
        } else if (currentPatrocinante === 2) {
            setPatrocinanteSeleccionado2(patrocinante);
            setFormData2(prevData => ({ ...prevData, patrocinante_id2: patrocinante.id }));
        } else if (currentPatrocinante === 3) {
            setPatrocinanteSeleccionado3(patrocinante);
            setFormData2(prevData => ({ ...prevData, patrocinante_id3: patrocinante.id }));
        }
        handleCloseModal();
    };

    
   
    const [filterOptions, setFilterOptions] = useState({
        cohorteOptions: [],
        centroOptions: [],
        periodoOptions: [],
        areaOptions: [],
        modalidadOptions: [],
        tipoProgramaOptions: [],
        nivelOptions: [],
        unidadOptions: [],
        grupoOptions:[],
    });

      const [filterOptions2, setFilterOptions2] = useState({
        nivelInstruccionOptions: [],
        estadoOptions: [],
        generoOptions: [],
        grupoOptions: [],
        nacionalidadOptions: [],
        procedenciaOptions: [],
        superatecOptions: [],  
    });
    
      const [formData, setFormData] = useState({
        cedula_identidad: '',
        nombres: '',
        apellidos: '',
        fecha_nacimiento: '',
        direccion: '',
        direccion_email: '',
        telefono_casa: '',
        telefono_celular: '',
        nacionalidad_id: '',
        genero_id: '',
        grupo_prioritario_id: '',
        estado_id: '',
        procedencia_id: '',
        nivel_instruccion_id: '',
        como_entero_superatec_id: '',
        municipio:'',
        no_cedula:'',
        status:'',
      });

    const [formData2, setFormData2] = useState({
        cohorte: '',
        centro_id: '',
        periodo_id: '',
        es_patrocinado: '',
        grupo:'',
        observaciones:'',
        realiza_aporte:'',
        grupo:'',
        patrocinante_id:'',
        patrocinante_id2:'',
        patrocinante_id3:''

        
    });



  

        useEffect(() => {
      const fetchCodigoFalso = async () => {
          const cedula = formData.cedula_identidad || originalCedula || '';
    
        // Si originalCedula ya comienza por 'FE', no hacemos nada
         if (cedula.startsWith('F')) {
         setFormData(prev => ({
            ...prev,
            cedula_identidad: cedula,
          }));
          return; //  salimos antes de hacer request
        }
    
        try {
          const token = localStorage.getItem('token');
          const res = await axios.get('/datos-codigo-falso', {
            headers: { Authorization: `Bearer ${token}` }
          });
    
          setFormData(prev => ({
            ...prev,
            cedula_identidad: res.data,
          }));
        } catch (error) {
          console.error('Error generando código falso:', error);
        }
      };
    
      if (formData.no_cedula) {
        fetchCodigoFalso();
      }
    }, [formData.no_cedula, originalCedula]); 
    
    const getInscripcion = async () => {
        if (!inscripcionId) {
            setError('Error: ID de inscripción no proporcionado.');
            return;
        }
    
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/cursos_inscripcion/${inscripcionId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
    
            const inscripcionData = response.data;
            const participanteData = response.data.datos_identificacion;

            setInscripcion(inscripcionData);
            setDatos(response.data.datos_identificacion); 
            // Verificar si ya hay un estado seleccionado y cargar los municipios
              if (participanteData.estado_id) {
                  const estadoSeleccionado = estadosMunicipios.find(estado => estado.id_estado === parseInt(participanteData.estado_id));
                  if (estadoSeleccionado) {
                      setMunicipiosDisponibles(estadoSeleccionado.municipios);
                  }
              }
              
  
              setFormData({
                  ...datos,
              });
    
            setFormData({ ...participanteData });
            // Actualizar formData con datos de la inscripción
            setFormData2({
                cohorte: inscripcionData.cohorte || '',
                periodo_id: inscripcionData.periodo_id || '',
                centro_id: inscripcionData.centro_id || '',
                nivel_id: inscripcionData.nivel_id || '',
                es_patrocinado: inscripcionData.es_patrocinado || false,
                patrocinante_id: inscripcionData.patrocinante_id || '',
                patrocinante_id2: inscripcionData.patrocinante_id2 || '',
                patrocinante_id3: inscripcionData.patrocinante_id3 || '',
                observaciones: inscripcionData.observaciones || '',
                realiza_aporte: inscripcionData.realiza_aporte || false,

                grupo: inscripcionData.grupo || '',
            });
    
            // Si hay patrocinantes en la inscripción, obtener sus detalles del backend
            if (inscripcionData.patrocinante_id) {
                const patrocinante1 = await getPatrocinanteById(inscripcionData.patrocinante_id);
                if (patrocinante1) setPatrocinanteSeleccionado1(patrocinante1);
            }
    
            if (inscripcionData.patrocinante_id2) {
                const patrocinante2 = await getPatrocinanteById(inscripcionData.patrocinante_id2);
                if (patrocinante2) setPatrocinanteSeleccionado2(patrocinante2);
            }
    
            if (inscripcionData.patrocinante_id3) {
                const patrocinante3 = await getPatrocinanteById(inscripcionData.patrocinante_id3);
                if (patrocinante3) setPatrocinanteSeleccionado3(patrocinante3);
            }
    
            setLoading(false);
        } catch (error) {
            setError('Error fetching course');
            console.error('Error fetching course:', error);
        }
    };
    

    useEffect(() => {
        console.log("Valor actual de es_patrocinado:", formData2.es_patrocinado); // Debug
    
        if (String(formData2.es_patrocinado) === "true") {
            setMostrarPatrocinantes(true);
        } else {
            setMostrarPatrocinantes(false);
        }
    }, [formData2.es_patrocinado]);  // Se ejecuta cuando `formData.es_patrocinado` cambia

    

    
    

    const handleSeleccionar = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/select-inc`, {
                headers: { Authorization: `Bearer ${token}` }
            });
    
            const { cohorte, centro, periodo, area, tipo_programa, unidad, modalidad, nivel,grupo } = response.data;
    
            // Guardar las opciones en el estado de filterOptions
            setFilterOptions({
                cohorteOptions: cohorte || [],
                centroOptions: centro || [],
                periodoOptions: periodo || [],
                areaOptions: area || [],
                tipoProgramaOptions: tipo_programa || [],
                unidadOptions: unidad || [],
                modalidadOptions: modalidad || [],
                nivelOptions: nivel || [],
                grupoOptions: grupo || [],

            });
    
            setSelectVisible(true);  // Mostrar los selectores
        } catch (error) {
            console.error('Error fetching filter options:', error);
        }
    };

    const handleSeleccionar2 = async () => {
      try {
          const token = localStorage.getItem('token');
          const response = await axios.get(`/filter-datos`, {
              headers: { Authorization: `Bearer ${token}` }
          });
    
          const {nivel_instruccion,estado,genero,grupo_prioritario,nacionalidad,procedencia,superatec} = response.data;
    
          // Guardar las opciones en el estado de filterOptions
          setFilterOptions2({
              nivelInstruccionOptions: nivel_instruccion,
              estadoOptions: estado,
              generoOptions: genero,
              grupoOptions:grupo_prioritario,
              nacionalidadOptions:nacionalidad,
              procedenciaOptions:procedencia,
              superatecOptions:superatec,
    
          });
    

    
    
          setSelectVisible(true);  // Mostrar los selectores
      } catch (error) {
          console.error('Error fetching filter options:', error);
      }
    };
    
    

    const [filtrosPatrocinante, setFiltrosPatrocinante] = useState({
        rif_cedula:'',
        nombre_patrocinante: '',
    });
    const getAllPatrocinantes = async (page = 1) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`/patrocinantes-paginate`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { ...filtrosPatrocinante, page }, // Incluye `page` en los parámetros
            });
    
            const { data, last_page, current_page } = response.data.patrocinantes;
    
            // Actualizar el estado
            setPaginatedPatrocinantes(data); // Datos de la página actual
            setCurrentPagePatrocinantes(current_page); // Página actual
            setTotalPages(last_page); // Total de páginas
            setPatrocinantes(data);
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Error fetching data');
            setPaginatedPatrocinantes([]); // Limpia los datos en caso de error
            setPatrocinantes([]);
        }
    };
    const handlePatrocinantesPageChange = async (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            await getAllPatrocinantes(newPage);
        }
      };
      const handleFilterPatrocinantesChange = (e) => {
        const { name, value } = e.target;
        setFiltrosPatrocinante(prev => ({ ...prev, [name]: value }));
      };

    

    const filteredPatrocinantes = Array.isArray(patrocinantes) 
        ? patrocinantes.filter(patrocinante =>
            patrocinante.rif_cedula.toLowerCase().includes(searchCedula.toLowerCase())
        )
        : [];
    
    
    // Llama a `fetchPatrocinantes` al abrir el modal:
    const handleOpenModal = () => {
        getAllPatrocinantes(currentPage);  // Obtener los patrocinantes de la página actual
        setShowModal(true);               // Mostrar el modal
    };
     // Llama a `fetchPatrocinantes` al abrir el modal:
     const handleOpenModalDelete = () => {
        setShowModalDelete(true);               // Mostrar el modal
    };
    const handleKeyDown = (e) => {
  if (e.key !== 'Backspace' && e.key !== 'Tab' && e.key !== 'Delete' && !/[0-9]/.test(e.key)) {
    e.preventDefault();
  }
};

     const handleDelete = async () => {
        try {
          const token = localStorage.getItem('token');
          await axios.delete(`/cursos_inscripcion/${inscripcionId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          await axios.delete(`/datos/${datos.id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          await axios.delete(`/peticiones/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          toast.success('Éxito al eliminar la inscripción');
          setShowModalDelete(false); // Cierra el modal tras la eliminación exitosa
          navigate(-1);
        } catch (error) {
          console.error('Error deleting inscripcion:', error);
          setError('Error al eliminar la inscripción');
          setShowModalDelete(false); // Cierra el modal tras el error
        }
      };

        const handleBlur = async () => {
          if (formData.cedula_identidad && formData.cedula_identidad !== originalCedula) {
            try {
              const token = localStorage.getItem('token'); 
              const response = await axios.get(`/datos/cedula/${formData.cedula_identidad}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              });
              setCedulaError('La cédula ya está registrada.');
              setIsCedulaValid(false);
            } catch (error) {
              if (error.response && error.response.status === 404) {
                setCedulaError('');
                setIsCedulaValid(true);
              } else {
                console.error('Error checking cedula:', error);
                setCedulaError('Error verificando la cédula.');
                setIsCedulaValid(false);
              }
            }
          }
        };
        


    // const handleSubmit = async () => {
    //     try {
    //         const token = localStorage.getItem('token');
            
    //         if (!token) {
    //             toast.error('Error: Token no encontrado');
    //             return;
    //         }
    
    //         const response = await axios.put(
    //             `/inscripcion_cursos/${inscripcionId}`, 
    //             { ...formData2, 
    //             status_pay: formData2.realiza_aporte === "false" && (!formData2.es_patrocinado || formData2.es_patrocinado === "false") ? 5 : (formData2.es_patrocinado === "true" ? 4 : 1), 
    //             patrocinante_id: formData2.es_patrocinado === "true" ? patrocinanteSeleccionado1?.id : null,
    //             patrocinante_id2: formData2.es_patrocinado === "true" ? patrocinanteSeleccionado2?.id || null :null,
    //             patrocinante_id3: formData2.es_patrocinado === "true" ? patrocinanteSeleccionado3?.id || null:null,
    //             check:true,



    //             }, // Datos a actualizar
    //             {
    //                 headers: {
    //                     Authorization: `Bearer ${token}`,
    //                     'Content-Type': 'application/json',
    //                 },
    //             }
    //         );
    //                 const dataToSend = {
    //                     ...formData,
    //                     status: true,
    //                 };
    //          // 1. Actualizar los datos del participante
    //             await axios.put(`/datos/${datos.id}`, dataToSend, {
    //               headers: {
    //                 Authorization: `Bearer ${token}`,
    //               },
    //             });

      

    //         //   Actualizar el status de la petición a true
    //          await axios.put(`/peticiones/${id}`, {
    //             status: true,   // Cambiar el estado a true
    //             finish_time : new Date().toISOString(),
    //             user_success: userId, // Enviar el usuario que completó la tarea
    //         }, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         });
          

    //           if ((formData.es_patrocinado === false || !formData.es_patrocinado)&& formData.realiza_aporte===true) {

    //                     const peticionResponse = await axios.post(`/peticiones`, {
    //                         zona_id: 3,
    //                         comentario: 'Pago no realizado',
    //                         user_id: userId,
    //                         role_id: 4,
    //                         status: false,
    //                         key: inscripcionId,  // Usar el ID de la inscripción como key
    //                     }, {
    //                         headers: { Authorization: `Bearer ${token}` },
    //                     });
    //                 }
    
    //         if (response.status === 200) {
    //             toast.success('Inscripción actualizada correctamente');
    //             navigate(-1);
    //             // Redirigir o realizar otra acción
    //         }
    //     } catch (error) {
    //         console.error('Error en la inscripción:', error);
    //         if (error.response && error.response.status === 401) {
    //             setError('Error: No autenticado. Por favor, inicie sesión nuevamente.');
    //             navigate('/login');
    //         } else {
    //             setError('Error al actualizar la inscripción');
    //         }
    //     }
    // };
    
    
const toBool = (val) => val === true || val === "true";

// Una inscripcion "tiene pago" si realiza aporte y no es patrocinada: es la
// misma condicion con la que despues se crea la peticion de pago.
const tienePago = !toBool(formData.es_patrocinado) && toBool(formData.realiza_aporte);
// U.C. aliada = curso externo (asi filtra la pantalla de U.C. Aliadas).
const esCursoAliado = [true, 'true', 1, '1', 't'].includes(inscripcion?.curso?.externo);

// Aprobar: si es una U.C. aliada con pago, primero se elige a quien va el
// registro del pago. Esos participantes no los atiende el asistente de centro,
// que es a quien se mandaban siempre.
const handleAprobar = () => {
  if (tienePago && esCursoAliado) {
    setShowDestinoPago(true);
    return;
  }
  handleSubmit(null);
};

const handleSubmit = async (destinoPago = null) => {
  // Solo se acepta un objeto { role_id, destinatario_id }: cualquier otra cosa
  // (por ejemplo un texto) se trata como "sin destinatario elegido".
  const destino = destinoPago && typeof destinoPago === 'object' ? destinoPago : null;
  try {
    const token = localStorage.getItem('token');
    
    if (!token) {
      toast.error('Error: Token no encontrado');
      return;
    }

    const response = await axios.put(
      `/inscripcion_cursos/${inscripcionId}`,
      {
        ...formData2,
        status_pay:
          !toBool(formData2.realiza_aporte) &&
          !toBool(formData2.es_patrocinado)
            ? 5
            : (toBool(formData2.es_patrocinado) ? 4 : 1),

        patrocinante_id: toBool(formData2.es_patrocinado)
          ? patrocinanteSeleccionado1?.id
          : null,

        patrocinante_id2: toBool(formData2.es_patrocinado)
          ? patrocinanteSeleccionado2?.id || null
          : null,

        patrocinante_id3: toBool(formData2.es_patrocinado)
          ? patrocinanteSeleccionado3?.id || null
          : null,

        check: true,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    const dataToSend = {
      ...formData,
      status: true,
    };

    // 1. Actualizar los datos del participante
    await axios.put(`/datos/${datos.id}`, dataToSend, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Actualizar el status de la petición a true
    await axios.put(
      `/peticiones/${id}`,
      {
        status: true,
        finish_time: new Date().toISOString(),
        user_success: userId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // Validación con bool o string
    if (!toBool(formData.es_patrocinado) && toBool(formData.realiza_aporte)) {
      await axios.post(
        `/peticiones`,
        {
          zona_id: 3,
          comentario: 'Pago no realizado',
          user_id: userId,
          // Si se eligio destinatario (U.C. aliada), va a ese rol o usuario;
          // si no, al rol 4 (asistente de centro), como siempre.
          role_id: destino ? destino.role_id : 4,
          destinatario_id: destino ? destino.destinatario_id : null,
          status: false,
          key: inscripcionId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    }

    if (response.status === 200) {
      toast.success('Inscripción actualizada correctamente');
      navigate(-1);
    }
  } catch (error) {
    console.error('Error en la inscripción:', error);
    if (error.response && error.response.status === 401) {
      setError('Error: No autenticado. Por favor, inicie sesión nuevamente.');
      navigate('/login');
    } else {
      setError('Error al actualizar la inscripción');
    }
  }
};

    if (error) {
        return <div>{error}</div>;
    }
 

    return (
    <div className="container-fluid" style={{ marginTop: '50px'}}>
      <Form onSubmit={(e) => handleSubmit(e, false)} className="custom-gutter">
    <div className="row justify-content-center" >
    
    <div className="col-lg-6 " > {/* Centrado del contenido */}
          <h2 className="mb-2">Confirmar Datos</h2>
          <div className="card-box" style={{ padding: '20px',  }}>
          <meta name="csrf-token" content="{{ csrf_token() }}" />
              <h4 className="mb-4">Datos del Participante</h4>
           
                             <Row className="g-2">
      <Col md={6}>
        {/* Select: ¿Sin cédula? */}
        <Form.Group controlId="no_cedula">
          <Form.Label>¿Posee Documento?</Form.Label>
          <Form.Select
            value={formData.no_cedula ? 'true' : 'false'}
            onChange={(e) => {
              const value = e.target.value === 'true';
              setFormData(prev => ({
                ...prev,
                no_cedula: value,
                // Reiniciar campos si cambia
                cedula_identidad: value ? prev.cedula_identidad : '',
              }));
            }}
          >
            <option value="false">Si</option>
            <option value="true">No</option>
          </Form.Select>
        </Form.Group>

        {!formData.no_cedula && (
          <Row className="g-2 align-items-end mt-2">
            <Col md={1}>
              <SelectComponent
                options={filterOptions2.nacionalidadOptions}
                nameField="descripcion"
                valueField="id"
                selectedValue={formData.nacionalidad_id}
                handleChange={handleChange}
                controlId="nacionalidad_id"
                label="Tipo"
              />
            </Col>

            <Col md={9}>
              <Form.Group controlId="cedula_identidad">
                <Form.Label>Número de Documento</Form.Label>
                <Form.Control
                  type="text"
                  name="cedula_identidad"
                  value={formData.cedula_identidad || ''}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                  onBlur={handleBlur}
                  placeholder="123321123"
                  maxLength={10}
                  required
                  className={
                    cedulaError || cedulaLengthError
                      ? 'is-invalid'
                      : isCedulaValid ? 'is-valid' : ''
                  }
                />
              </Form.Group>
            </Col>

            {cedulaError && <Alert variant="danger">{cedulaError}</Alert>}
            {!cedulaError && isCedulaValid && (
              <Form.Control.Feedback type="valid">
                Cédula disponible.
              </Form.Control.Feedback>
            )}
          </Row>
        )}

        {formData.no_cedula && (
          <div className="mt-3">
            <Form.Group controlId="cedula_falsa">
              <Form.Label>Cédula Falsa Generada</Form.Label>
              <Form.Control
                type="text"
                value={formData.cedula_identidad || ''}
                readOnly
              />
             
            </Form.Group>

            <Form.Group controlId="nacionalidad_id" className="mt-3">
              <Form.Label>Nacionalidad</Form.Label>
              <Form.Select
                name="nacionalidad_id"
                value={formData.nacionalidad_id || ''}
                onChange={handleChange}
              >
                <option value="">Seleccione</option>
                <option value="1">Extranjero</option>
                <option value="2">Venezolano</option>
              </Form.Select>
            </Form.Group>
          </div>
        )}
      </Col>
    </Row>


            <Row className="g-2"> 
            <Col md={6}>
            <Form.Group controlId="nombres">
              <Form.Label>Nombres</Form.Label>
              <Form.Control
                type="text"
                name="nombres"
                value={formData.nombres}
                onChange={handleChange}
                maxLength={255}
                
              />
            </Form.Group>
            </Col>
            <Col md={6}>
            <Form.Group controlId="apellidos">
              <Form.Label>Apellidos</Form.Label>
              <Form.Control
                type="text"
                name="apellidos"
                value={formData.apellidos}
                onChange={handleChange}
                maxLength={255}
                
              />
            </Form.Group>
            </Col>

            </Row>
            <Form.Group controlId="fecha_nacimiento">
              <Form.Label>Fecha de Nacimiento</Form.Label>
              <Form.Control
                type="date"
                name="fecha_nacimiento"
                min={FECHA_NAC_MIN}
                max={FECHA_NAC_MAX}
                value={formData.fecha_nacimiento}
                onChange={handleChange}
                
              />
            </Form.Group>
            
            <Row className="g-2"> 
            <Col md={6}>
            <SelectComponent
              options={filterOptions2.generoOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.genero_id}
              handleChange={handleChange}
              controlId="genero_id"
              label="Género"
            />
            
            </Col>
           
            </Row>
            <Row className="g-2"> 
            <Col md={6}>
              <Form.Group controlId="estado">
                <Form.Label>Estado</Form.Label>
                <Form.Select
                  name="estado_id"
                  value={formData.estado_id}
                  onChange={handleEstadoChange}
                >
                  <option value="">Seleccione </option>
                  {estadosMunicipios.map(estado => (
                    <option key={estado.id_estado} value={estado.id_estado}>
                      {estado.estado}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            
            <Col md={6}>
              <Form.Group controlId="municipio">
                <Form.Label>Municipio</Form.Label>
                <Form.Select
                  name="municipio"
                  value={formData.municipio}
                  onChange={(e) => setFormData({ ...formData, municipio: e.target.value })}
                  disabled={!municipiosDisponibles.length}  // Deshabilita si no hay municipios disponibles
                >
                  <option value="">Seleccione un Municipio</option>
                  {municipiosDisponibles.map((municipio, index) => (
                    <option key={index} value={municipio.municipio}>
                      {municipio.municipio}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

            <Form.Group controlId="direccion">
              <Form.Label>Dirección</Form.Label>
              <Form.Control
                as="textarea"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
                maxLength={255}
                
              />
            </Form.Group>

            <Row className="g-2"> 
            <SelectComponent
              options={filterOptions2.grupoOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.grupo_prioritario_id}
              handleChange={handleChange}
              controlId="grupo_prioritario_id"
              label="Grupo Prioritario"
            />
            </Row>
            <Row className="g-2"> 
            <Col md={6}>
            <SelectComponent
              options={filterOptions2.procedenciaOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.procedencia_id}
              handleChange={handleChange}
              controlId="procedencia_id"
              label="Procedencia"
            />
            </Col>
            <Col md={6}>
            <SelectComponent
             options={filterOptions2.nivelInstruccionOptions}  // Usar el estado filterOptions
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.nivel_instruccion_id}
              handleChange={handleChange}
              controlId="nivel_instruccion_id"
              label="Nivel de Instrucción"
            />
            </Col>
            </Row>

            <Form.Group controlId="direccion_email">
              <Form.Label>Dirección Email (Opcional)</Form.Label>
              <Form.Control
                type="email"
                name="direccion_email"
                value={formData.direccion_email}
                onChange={handleChange}
                
              />
            </Form.Group>
            
              <Row className="g-2"> 
                <Col md={6}>
                <Form.Group controlId="telefono_casa">
                  <Form.Label>Teléfono de Casa (Opcional)</Form.Label>
                  <Form.Control
                    type="text"
                    name="telefono_casa"
                    value={formData.telefono_casa}
                    onChange={handleChangeNumber}
                    maxLength={30}
                  />
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group controlId="telefono_celular">
                  <Form.Label>Teléfono Celular</Form.Label>
                  <Form.Control
                    type="text"
                    name="telefono_celular"
                    value={formData.telefono_celular}
                    onChange={handleChangeNumber}
                    maxLength={30}
                  />
                </Form.Group>
                </Col>
                </Row>
            <SelectComponent
              options={filterOptions2.superatecOptions}
              nameField="descripcion"
              valueField="id"
              selectedValue={formData.como_entero_superatec_id}
              handleChange={handleChange}
              controlId="como_entero_superatec_id"
              label="¿Cómo se enteró de Superatec?"
            />



              </div>
              </div>
            {/* Segunda Carta */}
      <div className="col-lg-5 "style={{ marginTop: '50px'}} >
      <div className="card-box" style={{ padding: '20px' }}>
          <h4 className="mb-4">Datos de Inscripción</h4>

          
           {selectVisible && filterOptions && (
                <div className="mt-3">
                    <Row className="g-2">
                    <Col md={6}>
                    {/* Cohorte Selector */}
                    {formErrors.cohorte && (
                    <div className="text-danger">{formErrors.cohorte}</div>
                )}
                    <SelectComponent
                        options={cohortesParaEdicion(filterOptions.cohorteOptions, formData2.cohorte)}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        insertValueField="descripcion"
                        selectedValue={formData2.cohorte}
                        handleChange={handleChange}
                        controlId="cohorte"
                        label="Cohorte"
                        required
                    />


                    {/* Centro Selector */}
                    {formErrors.centro_id && (
                    <div className="text-danger">{formErrors.centro_id}</div>
                )}
                    <SelectComponent
                        options={filterOptions.centroOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData2.centro_id}
                        handleChange={handleChange}
                        controlId="centro_id"
                        label="Centro"
                        required
                    />
                    </Col>

                    {/* Periodo Selector */}
                    {formErrors.periodo_id && (
                    <div className="text-danger">{formErrors.periodo_id}</div>
                )}
                    <SelectComponent
                        options={filterOptions.periodoOptions}  // Usar el estado filterOptions
                        nameField="descripcion"
                        valueField="id"
                        selectedValue={formData2.periodo_id}
                        handleChange={handleChange}
                        controlId="periodo_id"
                        label="Periodo"
                        required

                    />


                        </Row>
                         <SelectComponent
                                options={filterOptions.grupoOptions}  // Usar el estado filterOptions
                                nameField="descripcion"
                                valueField="id"
                                selectedValue={formData2.grupo}
                                handleChange={handleChange}
                                controlId="grupo"
                                label="Grupo"
                                required

                            />
                        <Form.Group controlId="realiza_aporte">
                        <Form.Label>¿Realiza Aporte?</Form.Label>
                        <Form.Control as="select" name="realiza_aporte" value={formData2.realiza_aporte} onChange={handleChange}>
                            <option value="">Seleccione</option>
                            <option value={true}>Sí</option>
                            <option value={false}>No</option>
                        </Form.Control>
                        </Form.Group>
                        
                        <Form.Group controlId="es_patrocinado">
                        <Form.Label>¿Es patrocinado?</Form.Label>
                        <Form.Control as="select" name="es_patrocinado" value={formData2.es_patrocinado} onChange={handleChange}>
                            <option value="">Seleccione</option>
                            <option value={true}>Sí</option>
                            <option value={false}>No</option>
                        </Form.Control>
                        

                        </Form.Group>
                        
                        {/* Mostrar el campo de patrocinante solo si es_patrocinado es true */}
                        {mostrarPatrocinantes && (
                            <>
                                <Form.Group controlId="patrocinante1">
                                    <Form.Label>Patrocinante 1 (Obligatorio)</Form.Label>
                                    <div className="d-flex">
                                        <Form.Control 
                                            type="text" 
                                            value={patrocinanteSeleccionado1 ? patrocinanteSeleccionado1.nombre_patrocinante : 'No seleccionado'} 
                                            readOnly 
                                        />
                                        <Button variant="secondary" onClick={() => { setCurrentPatrocinante(1); handleOpenModal(); }} className="ms-2">
                                            {patrocinanteSeleccionado1 ? 'Cambiar' : 'Seleccionar'}
                                        </Button>
                                        {patrocinanteSeleccionado1 && (
                                            <Button variant="danger" onClick={() => setPatrocinanteSeleccionado1(null)} className="ms-2">
                                                Deseleccionar
                                            </Button>
                                        )}
                                    </div>
                                </Form.Group>
                                
                                <Form.Group controlId="patrocinante2">
                                    <Form.Label>Patrocinante 2 (Opcional)</Form.Label>
                                    <div className="d-flex">
                                        <Form.Control 
                                            type="text" 
                                            value={patrocinanteSeleccionado2 ? patrocinanteSeleccionado2.nombre_patrocinante : 'No seleccionado'} 
                                            readOnly 
                                        />
                                        <Button variant="secondary" onClick={() => { setCurrentPatrocinante(2); handleOpenModal(); }} className="ms-2">
                                            {patrocinanteSeleccionado2 ? 'Cambiar' : 'Seleccionar'}
                                        </Button>
                                        {patrocinanteSeleccionado2 && (
                                            <Button variant="danger" onClick={() => setPatrocinanteSeleccionado2(null)} className="ms-2">
                                                Deseleccionar
                                            </Button>
                                        )}
                                    </div>
                                </Form.Group>

                                <Form.Group controlId="patrocinante3">
                                    <Form.Label>Patrocinante 3 (Opcional)</Form.Label>
                                    <div className="d-flex">
                                        <Form.Control 
                                            type="text" 
                                            value={patrocinanteSeleccionado3 ? patrocinanteSeleccionado3.nombre_patrocinante : 'No seleccionado'} 
                                            readOnly 
                                        />
                                        <Button variant="secondary" onClick={() => { setCurrentPatrocinante(3); handleOpenModal(); }} className="ms-2">
                                            {patrocinanteSeleccionado3 ? 'Cambiar' : 'Seleccionar'}
                                        </Button>
                                        {patrocinanteSeleccionado3 && (
                                            <Button variant="danger" onClick={() => setPatrocinanteSeleccionado3(null)} className="ms-2">
                                                Deseleccionar
                                            </Button>
                                        )}
                                    </div>
                                </Form.Group>
                            </>
                        )}

                            {formErrors.general && (
            <div className="text-danger">{formErrors.general}</div>
        )}
                  
                        <Form.Group controlId="observaciones">
                        <Form.Label>Observaciones</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="observaciones"
                            value={formData2.observaciones}
                            onChange={handleChange}
                        />
                        </Form.Group>
                        
                            <div className="d-flex justify-content-around">
                                
                                </div>  
                            </div>
                        )}
          
            
        </div>
        <EnviarPeticionModal
                  show={showDestinoPago}
                  titulo="¿A quién se envía el registro del pago?"
                  descripcion="Esta inscripción es de una U.C. aliada y tiene pago pendiente. Elija el rol o el usuario que va a registrar el pago; le llegará a su Bandeja."
                  onCancelar={() => setShowDestinoPago(false)}
                  onConfirmar={(destino) => {
                      setShowDestinoPago(false);
                      handleSubmit(destino);
                  }}
              />
        <div className="button-container"  >
               <Button 
                  variant="success" 
                  onClick={handleAprobar} 
                  className="mt-3" 
                  style={{ marginRight: "10px" }}
              >
                  Aprobar
              </Button>
              <Button 
                  variant="danger" 
                  onClick={() => handleOpenModalDelete('Rechazar')} 
                  className="mt-3" 
                  style={{ marginRight: "10px" }}
              >
                  Rechazar
              </Button>

              <Button variant="secondary" onClick={() => navigate(-1)}   className='mt-3 '>
                  Volver
              </Button>
            </div>
        
      </div>
      {/* Modal de Patrocinante */}
       <Modal show={showModal} onHide={handleCloseModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Seleccionar Patrocinante</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <div className="d-flex align-items-center">

                        <Form.Control 
                            name="rif_cedula"
                            type="text" 
                            placeholder="Buscar por Rif/Cédula" 
                            value={filtrosPatrocinante.rif_cedula}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Form.Control 
                            name="nombre_patrocinante"
                            type="text" 
                            placeholder="Buscar por Nombre" 
                            value={filtrosPatrocinante.nombre_patrocinante}
                            onChange={handleFilterPatrocinantesChange} 
                            className="mb-3"
                        />
                        <Button 
                            variant="info me-2" 
                            onClick={getAllPatrocinantes}
                            style={{ padding: '5px 10px', width: '120px' }} // Ajusta padding y ancho
                        >
                            <FaSearch className="me-1" /> {/* Ícono de lupa */}
                        </Button>
                    </div>

                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Rif/Cédula</th>
                                    <th>Nombre</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                                {paginatedPatrocinantes.map((patrocinante) => (
                                    <tr key={patrocinante.id}>
                                        <td>{patrocinante.rif_cedula}</td>
                                        <td>{patrocinante.nombre_patrocinante}</td>
                                        <td>
                                            <div className="d-flex justify-content-center align-items-center">
                                                <Button variant="info" onClick={() => handleSeleccionarPatrocinante(patrocinante)} className="me-2">
                                                    <i className="bi bi-check2-square"></i>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="d-flex justify-content-between mt-3">
                            

                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes - 1)}
                                disabled={currentPagePatrocinantes === 1}
                            >
                                Anterior
                            </Button>
                            

                            <Button
                                variant="secondary"
                                onClick={() => handlePatrocinantesPageChange(currentPagePatrocinantes + 1)}
                                disabled={currentPagePatrocinantes === totalPages}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModal}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
      
   {/* Modal de Desaprobar */}
                    <Modal show={showModalDelete} onHide={handleCloseModalDelete}>
                      <Modal.Header closeButton>
                        <Modal.Title>Confirmar Rechazo</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>¿Estás seguro de que deseas rechazar este participante e inscripción?</Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseModalDelete}>
                          Cancelar
                        </Button>
                        <Button variant="danger" onClick={handleDelete}>
                          Eliminar
                        </Button>
                      </Modal.Footer>
                    </Modal>

    </div>
    </Form>
    </div>
  );
};

export default ConfirmPartEInsc;
